import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import dict from './modules/dict'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    dict
  },
  getters
})

export default store
